import gql from 'graphql-tag'

export default gql`
  query CustomersGlobalsQuery($email: String) {
    customer(email: $email) {
      id
    }
  }
`
